import classname from "classnames";
import { MENU_CODE, returnImgByMenuCode } from "constants/layout";
import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, withRouter } from "react-router-dom";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
const menu = [
  //   {
  //     id: 34,
  //     menuName: "Thông báo từ TCT",
  //     menuCode: MENU_CODE.NOTICE_FROM_TCT.code,
  //     menuOrder: 10,
  //     parentId: null,
  //     sys: null,
  //     superAdmin: null,
  //     urlPropertyName: null,
  //     moduleName: "home",
  //     menuType: null,
  //     menuPublic: null,
  //     historyToken: "/notice-from-TCT",
  //     children: [],
  //   },

  {
    id: 34,
    menuName: "Hóa đơn",
    menuCode: MENU_CODE.ISSUE_VAT_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Lập hóa đơn",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/create",
        children: [],
      },
      {
        id: 35,
        menuName: "Lưu tạm",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/new",
        children: [],
      },
      {
        id: 35,
        menuName: "Đã phát hành",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/release",
        children: [],
      },
      {
        id: 35,
        menuName: "Chờ phát hành",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/wait-release",
        children: [],
      },
      {
        id: 35,
        menuName: "Hủy",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/cancel",
        children: [],
      },
      {
        id: 35,
        menuName: "Thay thế",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/replace",
        children: [],
      },
      {
        id: 35,
        menuName: "Điều chỉnh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/adjust",
        children: [],
      },
      {
        id: 35,
        menuName: "Tất cả",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice/all",
        children: [],
      },
    ],
  },
  //   {
  //     id: 34,
  //     menuName: "Hóa đơn GTGT",
  //     menuCode: MENU_CODE.ISSUE_VAT_INVOICE.code,
  //     menuOrder: 10,
  //     parentId: null,
  //     sys: null,
  //     superAdmin: null,
  //     urlPropertyName: null,
  //     moduleName: "home",
  //     menuType: null,
  //     menuPublic: null,
  //     historyToken: null,
  //     children: [
  //       {
  //         id: 35,
  //         menuName: "HĐ GTGT có mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-vat-invoice/have-code",
  //         children: [],
  //       },
  //       {
  //         id: 35,
  //         menuName: "HĐ GTGT không mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-vat-invoice/none-code",
  //         children: [],
  //       },
  //     ],
  //   },
  //   {
  //     id: 34,
  //     menuName: "Hóa đơn BH",
  //     menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
  //     menuOrder: 10,
  //     parentId: null,
  //     sys: null,
  //     superAdmin: null,
  //     urlPropertyName: null,
  //     moduleName: "home",
  //     menuType: null,
  //     menuPublic: null,
  //     historyToken: null,
  //     children: [
  //       {
  //         id: 35,
  //         menuName: "HĐ BH có mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-sales-invoice/have-code",
  //         children: [],
  //       },
  //       {
  //         id: 35,
  //         menuName: "HĐ BH không mã",
  //         menuCode: "ROLE",
  //         menuOrder: 20,
  //         parentId: 34,
  //         sys: null,
  //         superAdmin: null,
  //         urlPropertyName: "ECONTRACT",
  //         moduleName: "home",
  //         menuType: null,
  //         menuPublic: null,
  //         historyToken: "/issue-sales-invoice/none-code",
  //         children: [],
  //       },
  //     ],
  //   },

  {
    id: 40,
    menuName: "Hóa đơn sai sót",
    menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 41,
        menuName: "Lập thông báo hóa đơn sai sót",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/error-invoices/create",
        children: [],
      },
      {
        id: 41,
        menuName: "Danh sách hóa đơn sai sót",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/error-invoices",
        children: [],
      },
    ],
  },
  {
    id: 40,
    menuName: "Hóa đơn khác",
    menuCode: MENU_CODE.ISSUE_SALES_INVOICE.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      //   {
      //     id: 41,
      //     menuName: "Tem phiếu",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/issue-invoice-tickets",
      //     children: [],
      //   },
      {
        id: 41,
        menuName: "Phiếu xuất kho kiêm vc nội bộ",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-warehouses",
        children: [],
      },
      {
        id: 41,
        menuName: "Phiếu xuất kho gửi bán đại lý",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-warehouses-agency",
        children: [],
      },
      {
        id: 41,
        menuName: "Danh sách hóa đơn tổng",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-total",
        children: [],
      },
      {
        id: 41,
        menuName: "Phát hành hóa đơn theo lô",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-campaign",
        children: [],
        roleAccess: [ROLE_EINVOICE_KE_TOAN],
      },
      {
        id: 41,
        menuName: "Hóa đơn treo / lỗi truyền nhận",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-error-tct",
        children: [],
      },
    ],
  },
  {
    id: 34,
    menuName: "Tờ khai đăng ký",
    menuCode: MENU_CODE.DATA_FORMAT.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: "/data-format/registry-invoice",
    children: [
      //   {
      //     id: 35,
      //     menuName: "Đăng ký sử dụng",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/data-format/registry-invoice",
      //     children: [],
      //   },
      //   {
      //     id: 35,
      //     menuName: "Ủy quyền lập hóa đơn",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/data-format/registry-delegate",
      //     children: [],
      //   },
      //   {
      //     id: 35,
      //     menuName: "Đề nghị cấp HDDT có mã",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/data-format/request-invoice-code",
      //     children: [],
      //   },
    ],
  },
  {
    id: 34,
    menuName: "Báo cáo",
    menuCode: MENU_CODE.REPORT.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: "",
    children: [
      //   {
      //     id: 35,
      //     menuName: "Bảng tổng hợp dữ liệu Hóa Đơn",
      //     menuCode: "ROLE",
      //     menuOrder: 20,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/report/list-invoice-cycles",
      //     children: [],
      //   },
      {
        id: 35,
        menuName: "Bảng kê dữ liệu Hóa đơn / Phiếu xuất kho",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/report/list-report-invoice",
        children: [],
      },
      {
        id: 35,
        menuName: "Bảng kê tình hình sử dụng Hóa đơn / Phiếu xuất kho",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/report/list-report-invoice-use",
        children: [],
      },
      {
        id: 35,
        menuName: "Bảng kê hóa đơn tổng",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/report/list-report-invoice-total",
        children: [],
      },
      {
        id: 35,
        menuName: "Bảng tổng hợp hóa đơn sai sót 04/SS-HĐĐT",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/report/list-report-invoice-error",
        children: [],
      },
    ],
  },
  {
    id: 34,
    menuName: "Danh mục",
    menuCode: MENU_CODE.GENERAL_INFORMATIONS.code,
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    historyToken: null,
    children: [
      {
        id: 35,
        menuName: "Danh sách đơn vị kinh doanh",
        menuCode: "ROLE",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/business-unit-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách tiền tệ",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/currency-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách VAT",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/vat-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách phương thức thanh toán",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/payment-method-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách ký hiệu hóa đơn",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/invoice-symbol-manager/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách sản phẩm/ dịch vụ",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/product/list",
        children: [],
      },
      {
        id: 36,
        menuName: "Danh sách khách hàng",
        menuCode: "USER_ROLE",
        menuOrder: 30,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "ECONTRACT",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        historyToken: "/customer/list",
        children: [],
      },
      //   {
      //     id: 36,
      //     menuName: "Mẫu email doanh nghiệp",
      //     menuCode: "USER_ROLE",
      //     menuOrder: 30,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/business-email-templates",
      //     children: [],
      //   },
      //   {
      //     id: 36,
      //     menuName: "Danh sách hóa đơn mẫu",
      //     menuCode: "USER_ROLE",
      //     menuOrder: 30,
      //     parentId: 34,
      //     sys: null,
      //     superAdmin: null,
      //     urlPropertyName: "ECONTRACT",
      //     moduleName: "home",
      //     menuType: null,
      //     menuPublic: null,
      //     historyToken: "/invoice-templates",
      //     children: [],
      //   },
    ],
  },
];

const ConfigMenu = props => {
  const { t, i18n } = useTranslation();
  // const { menuArr } = props;
  const [menuOpen, setMenuOpen] = useState({});
  const [roles, setRoles] = useState([]);

  const toggleMenu = key => {
    setMenuOpen(prevMenuOpen => ({
      ...prevMenuOpen,
      [key]: !prevMenuOpen[key],
    }));
  };

  // Action Dispatch
  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setRoles(listRole);
    }
  }, []);

  return (
    <React.Fragment>
      {menu.map((childItem, index) => {
        return (
          <React.Fragment key={index}>
            <li key={index} className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle arrow-none d-flex align-items-center"
                onClick={e => {
                  if (childItem.children.length > 0) {
                    e.preventDefault();
                    toggleMenu(index);
                  }
                }}
                to={childItem.historyToken ? childItem.historyToken : "/#"}
              >
                <i
                  className={returnImgByMenuCode(childItem.menuCode) + " me-2"}
                ></i>
                {childItem.menuName} {props.menuOpen}
                {childItem.children.length > 0 && (
                  <div className="arrow-down"></div>
                )}
              </Link>
              {childItem.children.length > 0 && (
                <div
                  className={classname("dropdown-menu", {
                    show: menuOpen[index],
                  })}
                >
                  {childItem.children.map((child, index1) => {
                    let dataHref = "";
                    if (child.moreToken) {
                      dataHref = child.moreToken.join("___");
                    }
                    if (
                      !child.roleAccess ||
                      (child.roleAccess &&
                        roles.filter(arr1Item =>
                          child.roleAccess.includes(arr1Item)
                        ).length > 0)
                    ) {
                      return (
                        <Link
                          key={index1}
                          className="dropdown-item"
                          to={child.historyToken
                            .toLowerCase()
                            .split("_")
                            .join("-")}
                          datahref={dataHref}
                        >
                          {/* <i
                            className={ret(
                              child.historyToken.toLowerCase().split("_").join("-")
                            )}
                          ></i> */}
                          <span style={{ marginLeft: "5px" }}>
                            {child.menuName}
                          </span>
                        </Link>
                      );
                    } else {
                      return <React.Fragment key={index1}></React.Fragment>;
                    }
                  })}
                </div>
              )}
            </li>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

ConfigMenu.propTypes = {
  lang: PropTypes.object,
  menuArr: PropTypes.any,
  menuOpen: PropTypes.any,
};

export default withRouter(ConfigMenu);
